import { useReducer } from "react";

export type MenuState = {
    services: 1 | 0,
    solutions: 1 | 0,
    company: 0 | 1
};

export type OpenState = null | 'services' | 'solutions' | 'company' | 'closeAll';

export function reducerMenuV2( state: MenuState, action: { type: OpenState } ): MenuState {

    if (action.type === 'services') {
        return { ...state, services: state.services === 0 ? 1 : 0 };
    }

    if ( action.type === 'solutions' ) {
        return { ...state, solutions: state.solutions === 0 ? 1 : 0 };
    }
    
    if ( action.type === 'company' ) {
        return { ...state, company: state.company === 0 ? 1 : 0 };
    }

    if ( action.type === 'closeAll' ) {
        return {
            services: 0,
            solutions: 0,
            company: 0
        }
    }
    
    return state;
}

export function useHeaderState() {

    const [ headerState, headerDispatch ] = useReducer(reducerMenuV2, { services: 0, solutions: 0, company: 0 });

    function wrapperHeaderDispatch (action: { type: OpenState }){
        headerDispatch(action);                   
    }

    function wrapperKeyboardDispatch(e: React.KeyboardEvent<HTMLDivElement>, action: { type: OpenState }) {
        if (['Space', 'Enter'].find(item => item === e.code) ) {
            wrapperHeaderDispatch(action);
        }        
    }

    return {
        headerState,
        headerDispatch,
        wrapperHeaderDispatch,
        wrapperKeyboardDispatch
    };
}